import clsx from "clsx";
import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import FAQSection from "screens/Landing/components/FAQSection";
import { DashboarBuyForm } from "screens/Landing/components/LandingHeroSection/components/DashboarBuyForm";
import { PresaleCard } from "screens/Landing/components/LandingHeroSection/components/PresaleCard";
import { useAccount } from "wagmi";
import TokensToReceive from "./TokensToReceive";
import { useZoomScale } from "hooks/useZoomScale";

const DashboardHeroSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();
  const { isConnected, address } = useAccount();
  const isWalletConnected = isConnected && address;
  const [is4kDisplay, setIs4kDisplay] = useState(false);

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const updateIs4kDisplay = () => {
      setIs4kDisplay(window.innerWidth >= 2160);
    };

    updateIs4kDisplay();
    window.addEventListener("resize", updateIs4kDisplay);

    return () => {
      window.removeEventListener("resize", updateIs4kDisplay);
    };
  }, []);

  const { scale } = useZoomScale();

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
    >
      <div
        className={clsx(
          "flex max-lg:flex-col max-lg:max-w-[600px] relative z-20 max-lg:px-[12px] lg:px-5 px-[0] max-w-[1296px] mx-auto justify-center",
        )}
        style={
          is4kDisplay
            ? {
                zoom: scale,
                display: "flex",
                justifyContent: "space-around",
              }
            : undefined
        }
      >
        <div className="flex  lg:gap-[32px] max-lg:flex-col-reverse relative w-full">
          <div className="flex flex-col relative lg:flex-1 w-full">
            <TokensToReceive />

            <div className="max-lg:hidden">
              <FAQSection isDashboard={true} />
            </div>
          </div>

          {isWalletConnected ? (
            <DashboarBuyForm />
          ) : (
            <PresaleCard isDashboard />
          )}
        </div>

        <div className="lg:hidden">
          <FAQSection isDashboard={true} />
        </div>
      </div>
    </motion.section>
  );
};

export default DashboardHeroSection;
